import { createSelector } from 'reselect';
import { getLocale } from 'actions/language/selectors';
import { isInRange } from 'helpers/DatepickerHelper';

/*** Basic Selectors ***/
export const getDatepickerDropdownOpen = (state) =>
  state.SHAWAnalytics.datepickerDropdownOpen;

export const getStartDate = (state) => state.SHAWAnalytics.startDate;

export const getEndDate = (state) => state.SHAWAnalytics.endDate;

export const getGroupFilter = (state) => state.SHAWAnalytics.groupFilter;

export const getSurveyEligibleResponses = (state) =>
  state.SHAWAnalytics.surveyDataEligibleResponses;

export const getSurveyRequestedCallbacks = (state) =>
  state.SHAWAnalytics.surveyDataRequestedCallback;

export const getSurveyStarts = (state) =>
  state.SHAWAnalytics.surveyStatisticsStart;

export const getSurveyCompletes = (state) =>
  state.SHAWAnalytics.surveyStatisticsComplete;

export const getShawData = (state) => state.SHAWAnalytics.shawData;

export const getIsLoading = (state) => state.SHAWAnalytics.isLoading;

/*** Memoized Selectors  ***/
export const getGroupFilterID = createSelector(
  [getGroupFilter],
  (groupFilter) => `"${groupFilter.id}"`
);

export const getCurrentDateRange = createSelector(
  [getStartDate, getEndDate],
  (startDate, endDate) =>
    `${startDate.format('YYYYMMDD')}-${endDate.format('YYYYMMDD')}`
);

/**
 * @return {String} The start timestamp in ISO-8601 format in quotes, for example: '"2019-11-27T00:00:00-05:00"'
 */
export const getStartTimeRequest = createSelector(
  [getStartDate],
  (startDate) => {
    const startOfDay = startDate.clone();
    return `"${startOfDay
      .hours(0)
      .minutes(0)
      .seconds(0)
      .format()}"`;
  }
);

/**
 * @return {String} The end timestamp in ISO-8601 format in quotes, for example: '"2019-11-27T23:59:59-05:00"'
 */
export const getEndTimeRequest = createSelector([getEndDate], (endDate) => {
  const endOfDay = endDate.clone();
  return `"${endOfDay
    .hours(23)
    .minutes(59)
    .seconds(59)
    .format()}"`;
});

const dateFormat = 'YYYY/MM/DD';

export const getDatepickerDropdownLabel = createSelector(
  [getStartDate, getEndDate, getLocale],
  (start, end, locale) => {
    const calendarFormat =
      locale === 'fr' ? 'dddd Do MMM YYYY' : 'dddd, MMM Do YYYY';
    start.locale(locale);
    return (
      isInRange(start, end) ||
      (start.isSame(end, 'day') && start.format(calendarFormat)) ||
      `${start.format(dateFormat)} - ${end.format(dateFormat)}`
    );
  }
);



// WEBPACK FOOTER //
// ./src/actions/SHAWAnalytics/selectors.js